import { Component, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { RoutesFacade, RouteDirectionFacade, RouteStopsFacade, RouteStopItem, RouteTripFacade } from '@ridango/components';
import { BaseComponent } from '@ridango/core';

import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-schedule-route-trip',
    templateUrl: './route-trip.component.html'
})
export class ScheduleRouteTripComponent extends BaseComponent implements OnInit, OnDestroy {
    @Input() routeId: number;
    @Input() directionId: string;
    @Input() stopId: number;
    @Input() tripId: number;

    routeName: string = null;
    directionName: string = null;
    selectedStop: RouteStopItem = null;

    routeStops$ = this.routeStopsFacade.routeStops$;
    tripLoading$ = this.routeTripFacade.loading$;
    routes$ = this.routesFacade.routes$;
    routeTripStops$ = this.routeTripFacade.tripStops$;


    @ViewChildren('listItem') listItems: QueryList<ElementRef>;
    constructor(
        private translate: TranslateService,
        private router: Router,
        private routesFacade: RoutesFacade,
        private routeDirectionFacade: RouteDirectionFacade,
        private routeStopsFacade: RouteStopsFacade,
        private routeTripFacade: RouteTripFacade,
    ) {
        super();
    }

    ngOnInit() {
        this.routesFacade.setSelectedRouteId(this.routeId);
        this.routeDirectionFacade.setSelectedRouteDirection(this.directionId);

        this.routeTripFacade.fetchRouteTrip(this.tripId);
        this.routeStopsFacade.fetchRouteStops(this.routeId, this.directionId);
        this.routeStopsFacade.setSelectedStop(this.stopId);
        this.routeStopsFacade.fetchRoutePolyline(this.routeId, this.directionId);


        this.routes$.pipe(takeUntil(this.componentDestroyed$)).subscribe((routes) => {
            if (routes && this.routeId && routes[this.routeId]) {
                this.routeName = routes[this.routeId].route_short_name;
            }
        });

        this.routeStops$.pipe(takeUntil(this.componentDestroyed$)).subscribe((stops) => {
            if (stops && this.stopId && stops[this.stopId]) {
                this.selectedStop = stops[this.stopId];
            }
        });

        this.routeDirectionFacade
            .getRouteDirections(this.routeId)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((directions) => {
                if (directions) {
                    this.directionName = directions[this.directionId].trip_short_name;
                }
            });
    }

    ngOnDestroy() {
        this.routeStopsFacade.resetRouteStops();
        super.ngOnDestroy();
    }

    back() {
        this.router.navigate([
            this.translate.currentLang, 'schedule',
            'routes', this.routeId,
            'directions', this.directionId,
            'stops', this.stopId
        ]);
    }
}
